const initialState = {
  isFeedbackFormsEnabled: false,
  dataCollectionDelay: 0,
  mockBrazeContentCards: false,
};

export default (state = initialState, { type, value }) => {
  switch (type) {
    case "FEEDBACK_FORMS_ENABLED":
      return {
        ...state,
        isFeedbackFormsEnabled: value
      };
    case "DATA_COLLECTION_DELAY":
      return {
        ...state,
        dataCollectionDelay: value
      };
    case "MOCK_BRAZE_CONTENT_CARDS":
      return {
        ...state,
        mockBrazeContentCards: value === '1'
      };
    default:
      return state;
  }
};
